import { lazy } from 'react';

// project import
import Loadable from 'components/Loadable';
import MainLayout from 'layout/MainLayout';
import SMSAccount from 'pages/sms/SMSAccount';

// render - dashboard
//const DashboardDefault = Loadable(lazy(() => import('pages/dashboard')));

const Contact = Loadable(lazy(() => import('pages/contact')));
const ContactLists=Loadable(lazy(() => import('pages/contactlist')))
const Home = Loadable(lazy(() => import('pages/home')));

const Groups = Loadable(lazy(() => import('pages/groups')));

const Organizations = Loadable(lazy(() => import('pages/organizations')));
const OrganizationReport =Loadable(lazy(() => import('pages/organizations/OrganizationReport') ))
const Designations=Loadable(lazy(() => import('pages/designations')))
const Professions=Loadable(lazy(() => import('pages/professions')))

const Users=Loadable(lazy(() => import('pages/users')))

const Department=Loadable(lazy(() => import('pages/users/departments')))
const Branch=Loadable(lazy(() => import('pages/users/branch')))
const UpdatePassword=(lazy(()=> import('pages/profile')))
const UpdateProfile=(lazy(()=> import('pages/profile/UpdateProfile')))
const RenewPlan=Loadable(lazy(() => import('pages/plans/renew-plan')))
const UpgradePlan=Loadable(lazy(() => import('pages/plans/upgrade-plan')))

const MySubscriptions=Loadable(lazy(() => import('pages/plans/my-subscriptions')))
const OrganizationDepartment =Loadable(lazy(() => import('pages/department/index') ))
const CustomSMS = Loadable(lazy(()=>import('pages/sms/index')));
const SendBulkSMS = Loadable(lazy(() => import('pages/sendsms/SendBulkSMS')));
const SendCustomizedPersonalBulkSMS = Loadable(lazy(() => import('pages/sendsms/SendCustomizedPersonalBulkSMS')));
const SenderSettings = Loadable(lazy(() => import('pages/sender/index')));
const TemplateIDSettings = Loadable(lazy(() => import('pages/sms/TemplateIDSettings')));

const Task = Loadable(lazy(() => import('pages/tasks/index')));
const TaskDashboard=Loadable(lazy(() => import('pages/tasks/Dashboard')));
const TransactionReport = Loadable(lazy(() => import('pages/kithome/TransactionReport')));

// ==============================|| MAIN ROUTING ||============================== //

const MainRoutes = {
  path: '/',
  element: <MainLayout />,
  children: [
    {
      path: 'dashboard',
      element: <Home />
    },
    {
      path: 'contact',
      element: <Contact />
    },
    //   {
    //     path: 'paginate2',
    //     element: <Paginate2 />
    //   },

    //   {
    //     path: 'paginate3',
    //     element: <Paginate3 />
    //   },
    {
        path: 'contactlists',
        element: <ContactLists />
    },
    {
      path: 'group',
      element: <Groups />
    },
    {
      path: 'organizations',
      element: <Organizations />
    },
    {
      path: 'organizations-report',
      element: <OrganizationReport />
    },

    {
        path: 'organization-department',
        element: <OrganizationDepartment />
    },
    {
        path: 'designations',
        element: <Designations />
    },
    {
        path: 'professions',
        element:<Professions />
    },
    {
        path: 'custom-sms',
        element:<CustomSMS />
    },
    {
        path: 'sender',
        element:<SenderSettings />
    },
    {
        path: 'templateid-settings',
        element:<TemplateIDSettings />
    },
    {
        path: 'Users',
        element:<Users />
    },
    {
        path: 'Departments',
        element:<Department />
    },
    {
        path: 'branch',
        element:<Branch />
    },
    {
        path: 'update-password',
        element:<UpdatePassword />
    },
    {
        path: 'edit-profile',
        element:<UpdateProfile />
    },
    {
        path: 'upgrade-plan',
        element:<UpgradePlan />
    },
    {
        path: 'renew-plan',
        element:<RenewPlan />
    },
    {
        path: 'my-subscriptions',
        element:<MySubscriptions />
    },
    {
        path: 'sms-settings',
        element:<SMSAccount />
    },
    {
        path: 'send-bulk-sms',
        element:<SendBulkSMS />
    },
    {
        path: 'send-personalized-sms',
        element:<SendCustomizedPersonalBulkSMS />
    },
    {
        path: 'task-dashboard',
        element:<TaskDashboard />
    },
    {
        path: 'task',
        element:<Task />
    },
    {
        path: 'transaction-report',
        element:<TransactionReport />
    }

  ]
};

export default MainRoutes;
